module.exports = __webpack_public_path__ + "img/news-item.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/blog_type/single/img/news-item.jpg
// module id = 32
// module chunks = 0